export const LoginFormContent = () => (
    <div className="flex flex-col gap-2.5 w-full flex-shrink-0 h-full text-[var(--text-theme)]">
        <h4 className="text-2xl md:text-[1.625rem] lg:text-[1.75rem] xl:text-3xl 2xl-tall:text-[2rem] 3xl:text-[2.125rem]">
            Welcome Back
        </h4>

        <p className="text-xs">
            {`Get started with the Orbsway Vision Therapy: \n Expert-endorsed eye exercises for you.`}
        </p>
    </div>
)
